
import React from 'react'
import { FileText, ExternalLink, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { useNavigate } from 'react-router-dom'
import { useRecentResources } from '@/hooks/useRecentResources'

const ResourcesCard = () => {
  const navigate = useNavigate()
  const { recentResources } = useRecentResources()

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 flex-shrink-0">
        <CardTitle className="text-base font-medium">Recent Resources</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/resources')}
          className="h-8 px-2"
        >
          <ArrowRight className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="space-y-2 flex-1">
          {recentResources.length > 0 ? (
            recentResources.map((resource) => (
              <div key={resource.id} className="flex items-start justify-between p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors">
                <div className="flex items-start gap-3 flex-1">
                  <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <FileText className="w-4 h-4 text-blue-500" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-gray-900 text-sm break-words leading-relaxed">{resource.title}</h4>
                    {resource.description && (
                      <p className="text-xs text-gray-600 break-words leading-relaxed mt-1">{resource.description}</p>
                    )}
                    {resource.domain && (
                      <Badge variant="outline" className="text-xs mt-2">
                        {resource.domain}
                      </Badge>
                    )}
                  </div>
                  {resource.file_url && (
                    <Button
                      variant="ghost"
                      size="sm"
                      className="p-1 h-auto flex-shrink-0"
                      onClick={() => window.open(resource.file_url!, '_blank')}
                    >
                      <ExternalLink className="w-3 h-3" />
                    </Button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-8 text-center">
              <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center mb-4">
                <FileText className="w-6 h-6 text-blue-500" />
              </div>
              <p className="text-sm text-gray-500 mb-4">No resources opened yet</p>
            </div>
          )}
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          className="w-full mt-3 flex-shrink-0"
          onClick={() => navigate('/resources')}
        >
          <FileText className="w-4 h-4 mr-2" />
          Browse Resources
        </Button>
      </CardContent>
    </Card>
  )
}

export default ResourcesCard
